import { render, staticRenderFns } from "./UtenzeEdit.vue?vue&type=template&id=6bf430db&"
import script from "./UtenzeEdit.vue?vue&type=script&lang=ts&"
export * from "./UtenzeEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports